import React, { useEffect, useState } from "react";
import './ScrollButton.css'

export default function ScrollButton()
{
    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 2200) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    return (
        <div className="top-to-btm">
            {" "}
            {showTopBtn && (
                <button className="icon-position icon-style" onClick={goToTop}></button>
            )}{" "}
        </div>
    )
}